import moment from 'moment';

export function getItem(key) {
    let val = localStorage.getItem(key);
    if (val) {
        return JSON.parse(val)
    }
    return null;
}

export function saveItem(key, val) {
    localStorage.setItem(key, JSON.stringify(val));
}

export function removeItem(key) {
    localStorage.removeItem(key);
}

export function removeEventIdFromStorage() {
    localStorage.removeItem('vmeventid');
}

export function removeAllItems() {
    localStorage.clear();
}

export function saveEventIdToStorage(date, eventId) {
    const dateFormatted = moment(date).format("YYYY/MM/DD");
    const value = {
        eventId: eventId,
        expiry: dateFormatted
    }
    localStorage.setItem("vmeventid", JSON.stringify(value));
}

export function saveDataToStorage(key, value, noOfDaysToExpire) {
    var dateFormattedExpiry = moment(new Date(), "YYYY/MM/DD").utc().add(noOfDaysToExpire, 'days');
    const value_ = {
        value: value,
        expiry: dateFormattedExpiry
    }
    localStorage.setItem(key, JSON.stringify(value_));
}

export function loadDataFromStorage(key) {
    const data = JSON.parse(localStorage.getItem(key));
    if (data) {
        const isExpired = moment(data.expiry, "YYYY/MM/DD").isBefore(moment());
        if (isExpired) {
            return null;
        } else {
            return data
        }
    } else {
        return null;
    }
}

export function loadVmEventIdFromStorage() {
    const vmeventid = JSON.parse(localStorage.getItem("vmeventid"));
    if (vmeventid) {
        const isExpired = moment(vmeventid.expiry, "YYYY/MM/DD").isBefore(moment());
        if (isExpired) {
            return null;
        } else {
            return vmeventid.eventId
        }
    } else {
        return null;
    }
}

export function saveNoPopupValueToStorage(popupValue) {
    const dateFormatted = moment().add(30, 'minutes').toDate();
    const value = {
        popupValue: popupValue,
        expiry: dateFormatted
    }
    localStorage.setItem("vmPopUpValue", JSON.stringify(value));
}

export function loadNoPopupValueFromStorage() {
    const vmNoPopupValue = JSON.parse(localStorage.getItem("vmPopUpValue"));
    if (vmNoPopupValue) {
        const expired_ = moment(vmNoPopupValue.expiry).utc().toDate();
        const now = moment().utc().toDate();
        const isExpired = moment(expired_).isBefore(now);
        if (isExpired) {
            return null;
        } else {
            return vmNoPopupValue.popupValue
        }
    } else {
        return null;
    }
}

export function setVmFormCount(leadformVisibleCount) {
    if (leadformVisibleCount.toString() !== "") {
        const dateFormatted = moment().add(30, 'minutes').unix();
        const value = {
            leadformVisibleCount: leadformVisibleCount,
            expiry: dateFormatted
        }
        localStorage.setItem('vmformcount', JSON.stringify(value))
    }
}

export function loadVmFormCount() {

    let variable = localStorage.getItem('vmformcount');
    if (variable && typeof variable === "string") {
        let variable1 = JSON.parse(variable);
        if (moment().isSameOrBefore(variable1.expiry)) {
            return 0;
        } else {
            return variable1.leadformVisibleCount;
        }
    }
}

